export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8437.d90e46a7.jpg";